import { render, staticRenderFns } from "./ApiCall.vue?vue&type=template&id=002caf27&scoped=true&"
import script from "./ApiCall.vue?vue&type=script&lang=js&"
export * from "./ApiCall.vue?vue&type=script&lang=js&"
import style0 from "./ApiCall.vue?vue&type=style&index=0&id=002caf27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002caf27",
  null
  
)

export default component.exports